import React from "react";
import { FormAlphaNumericError, FormMaxError, FormRequiredError, FormNumberError, FormSelectError, FormWebsiteError, FormPhoneError, FormEmailError, FormMinError, FormGreatherThanEqualError } from "../../errors";

class ProductFormError extends React.Component {

    render() {
        let error = this.props.error.split('|');
        
        if (this.props.error.slice(-7) === "|number") {
            return <FormNumberError field_name={error[0]} />
        } else if (this.props.error.slice(-3) === "max") {
            return <FormMaxError field_name={error[0]} max={error[1]} />
        } else if (this.props.error.slice(-3) === "min") {
            return <FormMinError field_name={error[0]} min={error[1]} />
        } else if (this.props.error.slice(-3) === "gte") {
            return <FormGreatherThanEqualError field_name={error[0]} value={error[1]} />
        } else if (this.props.error.slice(-5) === "match") {
            return <FormAlphaNumericError field_name={error[0]} />
        } else if (this.props.error.slice(-6) === 'select') {
            return <FormSelectError field_name={error[0]} />
        } else if (this.props.error.slice(-5) === "phone") {
            return <FormPhoneError field_name={error[0]} />
        } else if (this.props.error.slice(-5) === "email") {
            return <FormEmailError field_name={error[0]} />
        } else if (this.props.error.slice(this.props.error.length - 7, this.props.error.length) === "invalid") {
            return <FormWebsiteError field_name={error[0]} />;
        } else {
            return <FormRequiredError field_name={this.props.error} />
        }
    }
}

export default ProductFormError;